import {
	btn,
	column,
	Config,
	createComponent,
	datasourcestore,
	DataSourceStore,
	menu,
	t,
	Table
} from "@intermesh/goui";
import {BoardDialog} from "./BoardDialog.js";
import {boardDS} from "./Index";

export class BoardGrid extends Table<DataSourceStore> {
	constructor() {
		const store = datasourcestore({
			dataSource: boardDS,
			sort: [{property: "name"}]
		});

		const columns = [
			column({
				id: "name"
			}),
			column({
				width: 48,
				id: "btn",
				sticky: true,
				renderer: (columnValue, record, td, table, storeIndex, column) => {
					return btn(
						{
							icon: "more_vert",
							menu: menu({},
								btn({
									icon: "edit",
									text: t("Edit"),
									disabled: !go.Modules.get("business", "kanban").userRights.mayManageBoards,
									handler: async (button, ev) => {
										const board = table.store.get(storeIndex)!;

										const dlg = new BoardDialog();
										await dlg.load(board.id);

										dlg.show();
									}
								}),
								btn({
									icon: "delete",
									text: t("Delete"),
									disabled: !go.Modules.get("business", "kanban").userRights.mayManageBoards,
									handler: async () => {
										const board = table.store.get(storeIndex)!;
										await boardDS.confirmDestroy([board.id]);
									}
								})
							)
						}
					)
				}
			})
		];

		super(store, columns);
	}
}
export const boardgrid = (config: Config<BoardGrid>) => createComponent(new BoardGrid(), config);